import { render, staticRenderFns } from "./full-draft-program.vue?vue&type=template&id=45d4c63b&scoped=true&"
import script from "./full-draft-program.vue?vue&type=script&lang=js&"
export * from "./full-draft-program.vue?vue&type=script&lang=js&"
import style0 from "./full-draft-program.vue?vue&type=style&index=0&id=45d4c63b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d4c63b",
  null
  
)

export default component.exports